import { createElementBlock as a, openBlock as l, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(r, e) {
  return l(), a("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "#1E0046",
      "fill-rule": "evenodd",
      d: "M13.331 2a1 1 0 0 0-2 0v1.889a1 1 0 1 0 2 0zm-5.12 10.031a4.12 4.12 0 1 1 8.24 0 4.12 4.12 0 0 1-8.24 0m4.12-6.12a6.12 6.12 0 1 0 0 12.24 6.12 6.12 0 0 0 0-12.24m0 13.263a1 1 0 0 1 1 1v1.889a1 1 0 0 1-2 0v-1.89a1 1 0 0 1 1-1m-10.32-8.166a1 1 0 1 0-.021 2l2.211.024a1 1 0 0 0 .021-2zm17.44 1a1 1 0 0 1 1-1h2.211a1 1 0 1 1 0 2H20.45a1 1 0 0 1-1-1m-7.12 1.476a1.476 1.476 0 1 0 0-2.952 1.476 1.476 0 0 0 0 2.952",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: o };
export {
  d as default,
  o as render
};
//# sourceMappingURL=ic_target-BD49uVpo.js.map
